export interface GlobalDocumentsState {
  getAllGlobalDocumentsSuccess: any;
  getAllGlobalDocumentsError: any;
  getAllGlobalDocumentsInProgress: boolean;
  cloneToCompanySuccess: any;
  cloneToCompanyError: any;
  cloneToCompanyInProgress: boolean;
  addGlobalDocumentSuccess: any;
  addGlobalDocumentError: any;
  addGlobalDocumentInProgress: boolean;
  getDocumentTypesSuccess: any;
  getDocumentTypesError: any;
  getDocumentTypesInProgress: boolean;
  editGlobalDocumentSuccess: any;
  editGlobalDocumentError: any;
  editGlobalDocumentInProgress: boolean;
  deleteGlobalDocumentSuccess: any;
  deleteGlobalDocumentError: any;
  deleteGlobalDocumentInProgress: boolean;
}

export const InitialGlobalDocumentsState: GlobalDocumentsState = {
  getAllGlobalDocumentsSuccess: null,
  getAllGlobalDocumentsError: null,
  getAllGlobalDocumentsInProgress: false,
  cloneToCompanySuccess: null,
  cloneToCompanyError: null,
  cloneToCompanyInProgress: false,
  addGlobalDocumentSuccess: null,
  addGlobalDocumentError: null,
  addGlobalDocumentInProgress: false,
  getDocumentTypesSuccess: null,
  getDocumentTypesError: null,
  getDocumentTypesInProgress: false,
  editGlobalDocumentSuccess: null,
  editGlobalDocumentError: null,
  editGlobalDocumentInProgress: false,
  deleteGlobalDocumentSuccess: null,
  deleteGlobalDocumentError: null,
  deleteGlobalDocumentInProgress: false,
};
